<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="products">
                    <icon name="tag"></icon>
                    สต็อคสินค้าทั้งหมด
                </b-nav-item>
                &nbsp

                <template
                    v-if="
                        canInventoryProductsImport ||
                            accessUserSpecial.includes(user.username)
                    "
                >
                    <b-nav-item router-link to="import_products">
                        <icon name="cart-arrow-down"></icon>
                        รายการนำเข้าสินค้า
                    </b-nav-item>
                </template>
                &nbsp
                <template
                    v-if="
                        canInventoryProductsExport ||
                            accessUserSpecial.includes(user.username)
                    "
                >
                    <b-nav-item router-link to="export_products">
                        <icon name="arrow-circle-right"></icon>
                        รายการนำออกสินค้า
                    </b-nav-item>
                </template>
                &nbsp
                <template v-if="canInventoryProductsExport">
                    <b-nav-item router-link to="products_type">
                        <icon name="arrow-circle-right"></icon>
                        หมวดสินค้า(เฉพาะ)
                    </b-nav-item>
                </template>
                &nbsp
                <template v-if="canInventoryProductsExport ||
                            accessUserSpecial.includes(user.username)">
                    <b-nav-item router-link to="products_invoice">
                        <icon name="arrow-circle-right"></icon>
                        รายการนำออกสินค้ารายบิล
                    </b-nav-item>
                </template>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
import {canInventoryProductsExport, canInventoryProductsImport} from "../../util/Permissions";
import {mapState} from "vuex";

export default {
    name: "products",
    data() {
        return {
            accessUserSpecial: ["10228", "10701", "10223", "20648", "10502"]
        };
    },
    computed: {
        canInventoryProductsImport,
        canInventoryProductsExport,
        ...mapState({
            user: state => {
                return state.Auth.user;
            }
        })
    }
};
</script>

<style scoped></style>
